import React, {FunctionComponent} from 'react';
import './InlineSpinner.less';

//@ts-ignore
import InlineSpinnerIcon from 'new-images/inline-spinner.svg';

export const InlineSpinnerStyles = {
	REGULAR: 'REGULAR',
	PRIMARY: 'PRIMARY'
};

const InlineSpinnerClasses = {
	[InlineSpinnerStyles.REGULAR]: 'inline-spinner--regular',
	[InlineSpinnerStyles.PRIMARY]: 'inline-spinner--primary'
};

interface InlineSpinnerProps {
	style: string
}

export const InlineSpinner: FunctionComponent<InlineSpinnerProps> = ({style = InlineSpinnerStyles.REGULAR}) => {
	return <span
		className={
			`inline-spinner
			${
				InlineSpinnerClasses[style]
			}`
		}
		dangerouslySetInnerHTML={{__html: InlineSpinnerIcon}}
	></span>;
};
